import { Box, HStack, Text, VStack } from '@chakra-ui/react'
import { ButtonLink } from '../navbar/ButtonLink';
import { WorkflowTextService } from '@/shared/WorkflowTextService';

export const StepTemplate = (props: {
  fileName: string
}) => {

  return (
    <Box w='lg' borderWidth={{ base: '0', md: '1px' }} p={{ base: '0', md: '4' }} borderRadius="lg">
      <HStack pr='4' w='full' spacing='4'>
        <VStack w='full' alignItems='start' spacing='0'>
          <Text fontWeight={600}>{props.fileName}</Text>
          <Text color="fg.subtle">{WorkflowTextService.getTemplateDescription(props.fileName)}</Text>
        </VStack>
        <ButtonLink to={`/admin/template/${props.fileName}`}>Edit</ButtonLink>
      </HStack>
    </Box>
  );
}